import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// User page icons
import { faUsers } from '@fortawesome/free-solid-svg-icons';
library.add(faUsers);
import { faSearch } from '@fortawesome/free-solid-svg-icons';
library.add(faSearch);
import { faUserEdit } from '@fortawesome/free-solid-svg-icons';
library.add(faUserEdit);

// Edit page icons
import { faUserCheck } from '@fortawesome/free-solid-svg-icons';
library.add(faUserCheck);
import { faUserMinus } from '@fortawesome/free-solid-svg-icons';
library.add(faUserMinus);
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
library.add(faUserPlus);
import { faPen } from '@fortawesome/free-solid-svg-icons';
library.add(faPen);
import { faMinus } from '@fortawesome/free-solid-svg-icons';
library.add(faMinus);
import { faUsersCog } from '@fortawesome/free-solid-svg-icons';
library.add(faUsersCog);
import { faTimes } from '@fortawesome/free-solid-svg-icons';
library.add(faTimes);

// Person editor
import { faUpload } from '@fortawesome/free-solid-svg-icons';
library.add(faUpload);

Vue.component('fa-icon', FontAwesomeIcon);
